<script>
    import UnsplashLink from '@/system/components/global/unsplash/UnsplashLink';

    export default {
        components: { UnsplashLink },

        data() {
            return {
                dropify_element: null,
                image: this.value,
            }
        },

        props: {
            name: {
                default: 'image'
            },

            max_file_size: {
                default: '1M'
            },

            allowed_file_extensions: {
                default: 'jpg png jpeg gif',
            },

            placeholder_text: {
                default: trans('online_booking.image_description')
            },

            default_file: {},

            error_text: {
                default: trans('settings.import_clients_dropify_error')
            },

            inputId: {
                default: null,
            },

            inputClass: {
                default: null,
            },

            enableUnsplash: {
                type: Boolean,
                default: false,
            },

            unsplashSearchQuery: {
                type: String,
                default: ''
            }
        },

        mounted() {

            // Initialize theme plugins
            this.$nextTick(() => {
                if (!this.dropify_element) {
                    this.dropify_element = $(this.$refs.image_upload).dropify({
                        tpl: {
                            clearButton: '<span class="remove-image"><i class="zmdi zmdi-close-circle"></i></span>',
                        },
                        messages: {
                            'default': this.placeholder_text,
                            'replace': trans('online_booking.image_dropify_replace'),
                            'remove': trans('settings.import_clients_dropify_remove'),
                        },
                        error: {
                            // 'fileSize': this.error_text ?? 'The file size is too big ({{ value }} max).',
                            // 'minWidth': this.error_text ?? 'The image width is too small ({{ value }}}px min).',
                            // 'maxWidth': this.error_text ?? 'The image width is too big ({{ value }}}px max).',
                            // 'minHeight': this.error_text ?? 'The image height is too small ({{ value }}}px min).',
                            // 'maxHeight': this.error_text ?? 'The image height is too big ({{ value }}px max).',
                            // 'imageFormat': this.error_text ?? 'The image format is not allowed ({{ value }} only).',
                            'fileExtension': this.error_text ?? 'The file is not allowed ({{ value }} only).'
                        }
                    });

                    $(this.$refs.image_upload).dropify().on('dropify.afterClear', (event, element) => {
                        this.image = null;
                        this.$emit('imageChange', null);
                    });
                }

                if (this.enableUnsplash) {
                    this.onUnsplashImageUpload();
                }
            });

            this.$event_bus.$on('clearImage', this.clearImage);
        },

        beforeUnmount() {
            let drDestroy = this.dropify_element.data('dropify');
            drDestroy.destroy();
        },

        methods: {
            handleUpdate(e) {
                var files =  e.target.files;
                this.image = files[0];
                this.$emit('imageChange', files[0]);
            },
            clearImage(){
                if (this.dropify_element) {
                    let drEvent = this.dropify_element.data('dropify');
                    drEvent.resetPreview();
                    drEvent.clearElement();
                }
            },

            onUnsplashImageUpload () {
                this.$event_bus.$on('unsplashImageUploaded', (image) => {
                    this.$emit('imageChange', image);
                });
            },
        },

        watch: {
            default_file(val) {
                if(this.dropify_element){
                    let drEvent = this.dropify_element.data('dropify');
                    drEvent.settings.defaultFile = val;
                    drEvent.destroy();
                    drEvent.init();
                }
                this.image = val;
            },
            value(val) {
                this.image = val;
            },
            image(val) {
                if(!val){
                    this.clearImage();
                }
            },
        },
    };
</script>

<template id="image-upload-input">

    <div class="image-upload-input-wrapper">

        <input type="file"
            :id="inputId"
            ref="image_upload"
            class=" form-control dropify"
            :class="inputClass"
            :data-max-file-size="max_file_size"
            :data-allowed-file-extensions="allowed_file_extensions"
            :name="name"
            :data-default-file="default_file"
            @change="handleUpdate"
        >

        <unsplash-link :query="unsplashSearchQuery" v-if="enableUnsplash" />
    </div>

</template>


